<script>
    import { onMount, createEventDispatcher } from 'svelte';
	  const dispatch = createEventDispatcher();
    let log = null
    onMount(() => {
        log = androidAdapter.listLog();
        if (log) {
            log = JSON.parse(log);
        }
    });

    function clear() {
      androidAdapter.clearLog();
      log = androidAdapter.listLog();
      if (log) {
          log = JSON.parse(log);
      }
    }

    function close() {
      dispatch('message', {
              type: "modal",
              modal: null
      });
    }
</script>

<div class="modal modal-lg active">
    <div class="modal-overlay" on:click={close} aria-label="Close"></div>
    <div id="modal-container" class="modal-container">
        <div class="modal-header">
            <div class="tile tile-centered">
                <div class="tile-content">
                    <div class="tile-title">Log</div>
                </div>
                <div class="tile-action">
                    <button class="btn btn-link" on:click={clear} aria-label="Clear"><i class="icon icon-delete mt-1"></i></button>
                    <button class="btn btn-link" on:click={close} aria-label="Close"><i class="icon icon-cross mt-1"></i></button>
                </div>
            </div>
        </div>
        <div class="modal-body">
          {#if log}
            <pre id="logText">
            {#each log as line}
              {line}<br />
            {/each}
            </pre>
          {/if}
        </div>
    </div>
</div>

<style>
    #logText {
      width: 100%;
      height: 100%;
      margin: 0;
    }
    .modal.modal-lg .modal-overlay {
        background: rgba(247, 248, 249, 0.75);
    }
    .modal.modal-lg .modal-container {
        height: 100vh;
        height: calc(var(--vh, 1vh) * 100);
        padding: 0;
    }
    .modal.modal-lg .modal-header {
        background-color: #00ab5f;
        color: #fff;
        padding: 0.2rem 0.4rem;
    }
    .modal.modal-lg .modal-header .btn.btn-link {
        color: white;
    }
    .modal.modal-lg .modal-body {
        padding: 0;
        height: calc(100vh - 2.1rem);
    }
    ::-webkit-scrollbar {
      width: 6px;
      background-color: #f7f8f9;
    }
	  ::-webkit-scrollbar-thumb {
		  background-color: rgba(122,129,132, 1);
    }
</style>